<template>
  <div>
    <el-select
      v-model="selectedRoleIds"
      :multiple="multiple"
      :multiple-limit="multipleLimit"
      style="width:310px;"
    >
      <el-option-group v-for="group in roleGroups" :key="group.id" :label="group.roleGroupName">
        <el-option
          v-for="item in group.roleDOS"
          :key="item.id"
          :label="item.roleName"
          :value="item.id"
        ></el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "SelectRolesByDropDown",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    multipleLimit: {
      type: Number,
      default: 0
    },

    defaultSelected: {}
  },
  watch: {
    defaultSelected: {
      handler(val) {
        this.selectedRoleIds = val;
      }
    },

    selectedRoles: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.$emit("byRoles", newValue);
      }
    }
  },
  created() {
    this.initRolesData();
  },

  computed: {
    allRoles() {
      var roles = [];
      this.roleGroups.forEach(item => {
        if (item.roleDOS && item.roleDOS.length) {
          roles.push(...item.roleDOS);
        }
      });
      return roles;
    },

    selectedRoles() {
      if (this.selectedRoleIds instanceof Array) {
        return this.allRoles.filter(
          item => this.selectedRoleIds.indexOf(item.id) > -1
        );
      }
      return this.allRoles.find(item => item.id === this.selectedRoleIds);
    }
  },

  data() {
    return {
      selectedRoleIds: "",
      roleGroups: []
    };
  },
  methods: {
    initRolesData() {
      this.$api
        .getRoles({
          getAll: true
        })
        .then(roles => (this.roleGroups = roles));
    }
  }
};
</script>

<style scoped>
/* iview 弹窗内部使用滚动条样式bug */
::v-deep .happy-scroll-container {
  height: 400px !important;
  width: 100% !important;
}
::v-deep .el-select-dropdown {
  z-index: 200000 !important;
}
</style>
